"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var useIsSmallScreen = function () {
    var isSmallScreen = (0, material_1.useMediaQuery)(function (theme) { return theme.breakpoints.down('md'); }, { noSsr: true });
    return isSmallScreen;
};
exports.default = useIsSmallScreen;
